import React from 'react';
import Meal from '@app/model/market_state/Meal';
import { Tooltip } from 'react-tooltip';
import BedAndBreakfast from '@images/icons/coffee-solid.svg';
import HalfBoard from '@images/icons/wine-glass-solid.svg';
import FullBoard from '@images/icons/champagne-glasses-solid.svg';
import AllInclusive from '@images/icons/crown-solid.svg';
import { MarketStateStatDateCompetitorSnapshot } from '@app/model/market_state/MarketStateStatDateCompetitorSnapshot';

const MealIndicator: React.FunctionComponent<{competitorSnapshot: MarketStateStatDateCompetitorSnapshot}> = ({competitorSnapshot}) => {

	const mealIcons: Map<Meal|undefined, React.ReactNode> = new Map([
		[undefined, <div/>],
		[Meal.NONE, <div/>],
		[Meal.BREAKFAST, <BedAndBreakfast className="h-4 w-4" data-tooltip-content="Bed & Breakfast" data-tooltip-id={`meal_indicator_${competitorSnapshot.competitorId}`} />],
		[Meal.HALF_BOARD, <HalfBoard className="h-4 w-4" data-tooltip-content="Half Board" data-tooltip-id={`meal_indicator_${competitorSnapshot.competitorId}`}/>],
		[Meal.FULL_BOARD, <FullBoard className="h-4 w-4" data-tooltip-content="Full Board" data-tooltip-id={`meal_indicator_${competitorSnapshot.competitorId}`}/>],
		[Meal.ALL_INCLUSIVE, <AllInclusive className="h-4 w-4" data-tooltip-content="All Inclusive" data-tooltip-id={`meal_indicator_${competitorSnapshot.competitorId}`}/>],
	])

	return competitorSnapshot.isAvailable() ? <>{mealIcons.get(competitorSnapshot.getLowestItemForRoom().lowestItem.item.meal)}<Tooltip id={`meal_indicator_${competitorSnapshot.competitorId}`}/></> : <div/>
}

export default MealIndicator;